// extracted by mini-css-extract-plugin
export default {"event":"InnerItem_event--vaH","favorite":"InnerItem_favorite--Wc7"};